/*************************************
 *
 * 缓存工具类
 * Author:smallsix@66629
 *
 *************************************/

import Storage from 'good-storage'

/**
 * 缓存 token
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function saveToken (value) {
  return saveLocalStorage('token', value)
}

/**
 * 获取token
 *
 * @param key
 *
 * @returns {*}
 */
export function getToken () {
  return getLocalStorage('token')
}

/**
 * 删除token
 *
 * @returns {*}
 */
export function deleteToken () {
  return saveLocalStorage('token', null)
}

/**
 * 缓存 Unionid
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function saveUnionid (value) {
  return saveLocalStorage('unionid', value)
}

/**
 * 获取 Unionid
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function getUnionid () {
  return getLocalStorage('unionid')
}

/**
 * 删除 Unionid
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function deleteUnionid () {
  return saveLocalStorage('unionid', null)
}

/**
 * 保存用户信息
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function saveUserInfo (value) {
  return saveLocalStorage('userInfo', value)
}

/**
 * 获取用户信息
 *
 * @param key
 *
 * @returns {*}
 */
export function getUserInfo () {
  return getLocalStorage('userInfo')
}

/**
 * 缓存 地址信息
 *
 * @param key
 * @param value
 */
export function saveAddressInfo (key, value) {
  saveSessionStorage(key, value)
}

/**
 * 获取缓存的地址信息
 *
 * @param key
 *
 * @returns {*}
 */
export function getAddressInfo (key) {
  return getSessionStorage(key)
}

/**
 * 保存 localStorage
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function saveLocalStorage (key, value) {
  Storage.set(key, value)
  return value
}

/**
 * 获取 localStorage
 *
 * @param key
 *
 * @returns {*|undefined}
 */
export function getLocalStorage (key) {
  return Storage.get(key)
}

/**
 * 保存 sessionStorage
 *
 * @param key
 * @param value
 *
 * @returns {*}
 */
export function saveSessionStorage (key, value) {
  Storage.session.set(key, value)
  return value
}

/**
 * 获取 sessionStorage
 *
 * @param key
 *
 * @returns {*|undefined}
 */
export function getSessionStorage (key) {
  return Storage.session.get(key)
}
/**
 * 保存砍价的商品信息
 *
 * @param key
 *
 * @returns {*|undefined}
 */
export function setBargainGoodsInfo (value) {
  return saveLocalStorage('bargainGoodsInfo', value)
}
/**
 * 获取砍价的商品信息
 *
 * @param key
 * @param key
 *
 * @returns {*|undefined}
 */
export function getBargainGoodsInfo () {
  return getLocalStorage('bargainGoodsInfo')
}
/**
 * 获取跳转地址
 *
 * @param key
 * @param key
 *
 * @returns {*|undefined}
 */
export function getLocalHref () {
  return getLocalStorage('localHref')
}

/**
 * 缓存跳转地址
 *
 * @param key
 * @param key
 *
 * @returns {*|undefined}
 */
export function saveLocalHref (value) {
  return saveLocalStorage('localHref', value)
}



// WEBPACK FOOTER //
// ./src/utils/webCache.js